import { Link } from "react-router-dom";
import { trackSelectItem } from "@/lib/analytics";
import { Badge } from "@/components/ui/badge";
import StarRating from "@/components/StarRating";
import { Zap } from "lucide-react";

export default function ProductCard({ product }) {
  return (
    <Link to={`/product/${product.slug}`} data-testid={`product-card-${product.slug}`}
      onClick={() => trackSelectItem(product, product.category)}
      className="group card-hover block rounded-2xl overflow-hidden bg-white border border-slate-100">
      <div className="relative aspect-[4/5] overflow-hidden bg-subtle">
        <img src={product.images?.[0]} alt={product.name} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        {product.is_instant_download && (
          <Badge className="absolute top-3 left-3 bg-sage text-white border-0 gap-1 font-semibold">
            <Zap className="w-3 h-3" /> Instant
          </Badge>
        )}
        {product.bestseller && !product.is_instant_download && (
          <Badge className="absolute top-3 left-3 bg-amber text-white border-0 font-semibold">Bestseller</Badge>
        )}
      </div>
      <div className="p-4">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-amber-700/70">{product.category}</p>
        <h3 className="font-display text-lg font-bold text-slateink mt-0.5 leading-tight">{product.name}</h3>
        <div className="flex items-center justify-between mt-2">
          <span className="text-slateink font-semibold">from ${Number(product.starting_price).toFixed(0)}</span>
          {product.avg_rating ? <StarRating value={product.avg_rating} size={13} /> : null}
        </div>
      </div>
    </Link>
  );
}
